import type { WorkspaceMembershipModalProps } from "@v1/types/modalTypes";

import * as React from "react";

import { Avatar } from "@replo/design-system/components/avatar/Avatar";
import { successToast } from "@v1/components/designSystem/alert/Toast";
import DeprecatedButton from "@v1/components/designSystem/button/Button";
import { Modal } from "@v1/components/designSystem/modal/Modal";
import { useModal } from "@v2/store/modalStore";
import { workspaceRouter, workspaceUtils } from "@v2/trpc/routes/workspace";

export const WorkspaceMembershipModal = ({
  workspaceId,
  workspaceName,
  email,
}: WorkspaceMembershipModalProps) => {
  const modal = useModal();

  const { mutate, isPending } = workspaceRouter.inviteMembers.useMutation({
    onSuccess: () => {
      void workspaceUtils.getWorkspaceAndProjectMembers.invalidate(workspaceId);
      modal.closeModal({ type: "workspaceMembershipModal" });
      modal.openModal({ type: "projectMembershipModal" });
      successToast("Invitation sent!", "The invitation was sent successfully.");
    },
  });

  return (
    <Modal
      title="Add to Workspace"
      description={`Do you want to add this person to the ${workspaceName} Workspace in addition to the project? They would have access to all projects in the workspace.`}
      onOpenChange={(open) => {
        if (!open) {
          modal.closeModal({ type: "workspaceMembershipModal" });
        }
      }}
      isOpen={true}
      size="sm"
      footer={
        <div className="flex flex-row justify-end gap-2">
          <DeprecatedButton
            variant="secondary"
            type="submit"
            size="base"
            onClick={() => {
              modal.closeModal({ type: "workspaceMembershipModal" });
              modal.openModal({ type: "projectMembershipModal" });
            }}
          >
            Just this project
          </DeprecatedButton>
          <DeprecatedButton
            variant="primary"
            type="submit"
            size="base"
            disabled={isPending}
            onClick={() => {
              void mutate({
                workspaceId,
                usersToGrantAccess: [
                  {
                    email,
                    role: "member",
                  },
                ],
              });
            }}
          >
            Invite to workspace
          </DeprecatedButton>
        </div>
      }
    >
      <UserRow email={email} />
    </Modal>
  );
};
const UserRow = ({ email }: { email: string }) => {
  return (
    <div className="flex items-center gap-2">
      <Avatar className="h-7 w-7" />
      <div className="text-muted flex flex-col items-start text-sm">
        {email}
      </div>
    </div>
  );
};
